/*
Copyright (c) 2026 Wind River Systems, Inc.

The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
*/
// Guards
import { AuthGuard, LogInGuard } from '@windriver/authentication';

// Components
import { APP_BASE_HREF } from '@angular/common';
import { ProfileComponent, DateTimeComponent, ToolsComponent, LoginComponent } from '@windriver/ui';
import { ProductsComponent } from './components/products/products.component';
import { ExternalLinkComponent } from './components/external-link/external-link.component';
import { InstallationGuideComponent } from './components/installation-guide/installation-guide.component';
import { PatchNotesComponent } from './components/patch-notes/patch-notes.component';
import { HelpFaqComponent } from './components/help-faq/help-faq.component';
import { LandingGuard } from './guards/landing.guard';

import { Routes, RouterModule } from '@angular/router';

// Layouts
import { HomeLayoutComponent } from './layouts/home-layout/home-layout.component';
// import { LandingGuard } from './guards/landing.guard';
// import { LandingLayoutComponent } from './layouts/landing-layout/landing-layout.component';
// import { LandingPageComponent } from './components/landing-page/landing-page.component';
import { LoginLayoutComponent } from './layouts/login-layout/login-layout.component';
import { NgModule } from '@angular/core';

// Configuration
import { environment } from '@environment';

const routes: Routes = [
  {
    path: '',
    data: { sideNavCategories: [environment.appName] },
    component: HomeLayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        canActivate: [LandingGuard],
        component: ProductsComponent
      },
      {
        path: 'home',
        redirectTo: ''
      },
      {
        path: 'installation-guide',
        pathMatch: 'full',
        component: InstallationGuideComponent
      },
      {
        path: 'settings',
        data: { sideNavCategories: ['User Settings'] },
        children: [
          {
            path: '',
            redirectTo: 'profile',
            pathMatch: 'full'
          },
          {
            path: 'profile',
            component: ProfileComponent
          },
          {
            path: 'date-time',
            component: DateTimeComponent
          },
          {
            path: 'tools',
            component: ToolsComponent
          }
        ]
      },
      {
        path: 'products',
        pathMatch: 'full',
        component: ProductsComponent
      },
      {
        path: 'documentation',
        pathMatch: 'full',
        component: ExternalLinkComponent,
        data: { url: environment.documentationUrl }
      },
      {
        path: 'support',
        pathMatch: 'full',
        component: ExternalLinkComponent,
        data: { url: environment.supportUrl }
      },
      {
        path: 'licenses',
        pathMatch: 'full',
        component: ExternalLinkComponent,
        data: { url: environment.licensesUrl }
      },
      {
        path: 'legal',
        pathMatch: 'full',
        component: HelpFaqComponent,
        data: { anchor: 'legal_notices' }
      },
      {
        path: 'help',
        pathMatch: 'full',
        component: HelpFaqComponent,
        data: { anchor: 'top' }
        // },
        // { // TODO: enable feedback function/route
        //   path: 'feedback',
        //   pathMatch: 'full',
        //   component: FeedbackComponent,
      },
      {
        path: 'patch-notes',
        pathMatch: 'full',
        component: PatchNotesComponent
      }
    ]
  },
  {
    path: '',
    component: LoginLayoutComponent,
    children: [
      {
        path: 'login',
        component: LoginComponent,
        canActivate: [LogInGuard]
      }
    ]
  },
  { path: '**', redirectTo: '/' }
];

@NgModule({
  providers: [{ provide: APP_BASE_HREF, useValue: '/portal/' }],
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy', scrollPositionRestoration: 'top' })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
